<template>
  <Tabs
    :bottom-border="true"
    :selected-tab="selectedTab"
    :should-scroll-active-element-into-view="true"
  >
    <Tab
      title="Locations"
      :to="locationsPath"
    />
    <Tab
      title="Daily Snows"
      to="/user/favorites/daily-snows"
    />
    <Tab
      title="Cams"
      to="/user/favorites/cams"
    />
    <Tab
      title="Passes"
      to="/user/favorites/season-passes"
    />
    <Tab
      title="Trail Maps"
      to="/user/favorites/trail-maps"
    />
  </Tabs>
</template>

<script>
import { useUserFavoritesStore } from '@@/stores/UserFavorites';

export default {
  name: 'FavoritesNavigation',

  props: {
    selectedTab: {
      type: Number,
      default: 0,
    },
  },

  setup() {
    const userFavoritesStore = useUserFavoritesStore();
    const activeList = userFavoritesStore.getActiveList;
    const { lastComparePageCookie } = useCompareUtils(activeList);

    let comparePage = 'snow-summary';

    if (lastComparePageCookie.value && userFavoritesStore.getLocationIdsForActiveList?.length > 0) {
      comparePage = lastComparePageCookie.value;
    }

    return { locationsPath: `/user/favorites/locations/${comparePage}` };
  },
};
</script>
